<template>
	<div class="magnify-box" v-if="boxVisible" @click="$emit('close-box', boxVisible)">
		<i class="icon el-icon-close button-hover"></i>
		<div class="pic-box">
			<img :src="url" />
			<p class="count" v-if="picLength>1">{{nowIndex}}/{{picLength}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: "magnify",
		props: ['boxVisible', 'imgUrl', 'nowIndex', 'picLength'],
		data() {
			return {
				show: this.boxVisible,
				url: this.imgUrl,
				index: this.nowIndex,
				length: this.picLength
			}
		},
		methods: {

		},
		mounted() {

		},
		watch: {
			boxVisible(newVal, oldVal) {
				this.show = newVal;
			},
			imgUrl(newVal, oldVal) {
				this.url = newVal;
			},
			nowIndex(newVal, oldVal) {
				this.index = newVal;
			},
			picLength(newVal, oldVal) {
				this.length = newVal;
			},
		}
	}
</script>

<style scoped>
	.magnify-box {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .5);
		color: #fff;
	}
	
	.magnify-box .pic-box {
		position: relative;
		font-size: 18px;
	}
	
	.magnify-box img {
		max-height: 937px;
		max-width: 1800px;
	}
	
	.magnify-box .count {
		position: absolute;
		bottom: 16px;
		width: 100%;
		text-align: center;
	}
	
	.magnify-box .icon {
		position: absolute;
		right: 40px;
		top: 40px;
		font-size: 30px;
		color: #ffffff;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/magnify.vue